import logger from './logger';
export function prepareCli({ welcomeMsg }) {
    if (!process.env.NODE_ENV) {
        process.env.NODE_ENV = 'development';
    }
    const { npm_execpath } = process.env;
    if (!npm_execpath ||
        npm_execpath.includes('npx-cli.js') ||
        npm_execpath.includes('.bun')) {
        console.log();
    }
    logger.info(welcomeMsg);
}
